import * as types from 'modules/predefinedMessages/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @type {string?} State */
const initialState = null;

const clearState = () => null;

const haveError = (_, { payload: message }) => message;

export default createReducer(initialState, {
  [types.FETCH_ALL_BY_DEALER]: clearState,
  [types.FETCH_ALL_BY_DEALER_FAILURE]: haveError,
});
